import {
    Box,
    debounce,
    LinearProgress,
    ToggleButton,
    ToggleButtonGroup,
    Typography,
} from "@mui/material";

import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import { useParams } from "react-router";
import { useCallback, useEffect, useState } from "react";
import { TListPart } from "../../../../explorer/types/SpareParts/PartList";
import useLanguages from "../../../../explorer/hooks/useLanguages";
import ServiceProvider from "../../../configuration/ServiceProvider";
import { reduxStoreConfig } from "../../../configuration/reduxStoreConfig";
import { Site } from "../../../../explorer/types/SpareParts/Site";
import { useReduxState } from "../../../../explorer/redux/hooks";
import {
    defaultLayoutSearch,
    gridSearchLayout,
    tableSearchLayout,
} from "../../../configuration/defaultSettings";

import {
    Root,
    Content,
    SearchResultHeaderContainer,
    SearchIconWrapper,
    LinearProgressWrapper,
    FilterBoxWrapper,
    ButtonsContainer,
    SubContainer,
    PageContainer,
    StyledToggleButton,
} from "./SearchPartsPage.styles";
import {
    AppIconsApp,
    AppIconsChecklist,
    AppIconsSearch2,
} from "../../../components/AppIcons";
import { useSearchClasses } from "./SearchPartsPage.styles";

import { FilterSearch } from "./Filter/FilterSearch";
import BreadcrumbComponent from "../../../components/Breadcrumb/BreadcrumbComponent";
import PartList, {
    ColumnAlign,
    ColumnWidth,
} from "../../../components/PartsList/PartList";
import BasketIconComponent from "../../../components/PartsList/TableLayout/TableColumnComponents/BasketIconComponent";
import ImageIconComponent from "../../../components/PartsList/TableLayout/TableColumnComponents/ImageIconComponent";
import ReplaceIconComponent from "../../../components/PartsList/TableLayout/TableColumnComponents/ReplaceIconComponent";
import useBrands from "../../../../explorer/hooks/useBrands";
import { Machine } from "../../../../explorer/types/SpareParts";
import { setLayoutSearch } from "../../../../explorer/utils/NavigationUtils";
import { usePartDetails } from "../../../hook/usePartDetails";
import useCurrentSite from "../../../hook/useCurrentSite";
import PartMccLogoComponent from "../../../components/PartsList/TableLayout/TableColumnComponents/PartMccLogoComponent";

const SearchPartsPage = () => {
    //Redux

    const { codeSearched } = useParams();

    const classes = useSearchClasses();

    const [layout, setLayout] = useReduxState<string>(
        reduxStoreConfig.sparePartsSearchLayout
    );

    const { t } = useTranslation();

    const [searching, setSearching] = useState(false);

    const [selectedSortType, setSelectedSortType] = useState<string>("");
    const [selectedMachineCode, setSelectedMachineCode] = useState<string>();
    const [selectedMachineLabel, setSelectedMachineLabel] = useState<string>("");

    const [applyFilter, setApplyFilter] = useState<boolean>(true);
    const [machineFilterApplied, setMachineFilterApplied] = useState<string>("");
    

    const [loaded, setLoaded] = useState(false);
    const [openFilters, setOpenFilters] = useState(false);

    const [items, setItems] = useState<TListPart[]>();
    const [searchText, setSearchText] = useState<string | undefined>();

    const [message, setMessage] = useState("");
    const currentLanguage = useLanguages().currentLanguage;

    const brand = useBrands().currentBrandUrl;
    const [siteSelected, setSiteSelected] = useCurrentSite();
    const [popoverAnchorElement, setPopoverAnchorElement] =
        useState<HTMLDivElement | null>(null);
    const [popoverMessage, setPopoverMessage] = useState<string | null>(null);

    const handleOpenFilters = (
        event: React.KeyboardEvent | React.MouseEvent
    ) => {
        setOpenFilters(true);
    };

    const [currentMachine, setCurrentMachine] = useState<Machine>();
    const addColumnLogo: boolean =
        useBrands().currentBrand!.manufacturers.length > 1;
    useEffect(() => {
        ServiceProvider.SpareParts.getLayoutSearch()
            .then((result) => {
                setLayoutSearch(result);
                setLayout(result);
            })
            .catch((e) => console.error(e));
    }, []);

    useEffect(() => {
        debugger;
        setSearchText(codeSearched);

        if (codeSearched && codeSearched.length >= 2) {
            setApplyFilter(true);
            debouncedApiCall(codeSearched);
        } else {
            resetSearch();
        }
    }, [codeSearched]);

    useEffect(() => {
        resetSearch();
    }, [siteSelected]);

    const debouncedApiCall = useCallback(
            debounce((text?: string) => {
                if (applyFilter) { searchItems(text) } ;
            }, 100),
        
        [applyFilter,selectedMachineCode, selectedSortType]
    );

    useEffect(()=>{
        setApplyFilter(true)
    }, [currentLanguage]);
    
    useEffect(() => {
        if (loaded && applyFilter) {
            if (codeSearched && codeSearched.length >= 2) {
                searchItems(codeSearched);
            } else {
                resetSearch();
            }
        } else {
            
            setLoaded(true);
        }
    }, [selectedSortType, selectedMachineCode,applyFilter ]);

    const searchItems = async (
        val?: string | null,
        searchSidelCustomerType?: string | null
    ) => {
        const searchString = val ? val : searchText;
        const sorting = selectedSortType === "" ? null : selectedSortType;

        try {
            resetSearch(false);
            setSearching(true);
            var params: any = {
                //language: 'EN',
                lang: currentLanguage,
                searchString: searchString,
            };

            if (sorting) params = { ...params, orderingType: sorting };
            if (selectedMachineCode !== undefined && selectedMachineCode !== "")
                params = { ...params, machineId: selectedMachineCode };
            const searchItemsResponse: any =
                await ServiceProvider.SpareParts.getParts(brand, params);
            setMachineFilterApplied(selectedMachineCode=="" ? "" : selectedMachineLabel)                
            setItems(searchItemsResponse);
            setSearching(false);
            setApplyFilter(false);
          
            
        } catch (err) {
            setApplyFilter(false);
            setSearching(false);
            console.error(err);
        }
    };

    const handleLayoutResult = (
        event: React.MouseEvent<HTMLElement>,
        newLayout: string | null
    ) => {
        if (newLayout !== null) {
            setSearching(true);
            setLayout(newLayout);
            ServiceProvider.SpareParts.setLayoutSearch(newLayout)
                .then((asyncResp) => {
                    setSearching(false);
                })
                .catch((error) => {
                    setSearching(false);
                    throw error;
                });
        }
    };

    const resetSearch = (init?: boolean) => {
        setItems(undefined);
    };

    /*FILTERS*/

    const [expandFilters, setExpandFilters] = useState(false);

    const handleFilterClick = function () {
        setOpenFilters(true);
        setExpandFilters(!expandFilters);
    };

    const { openPartDetails } = usePartDetails();

    const handleOpenPartDetail = (
        code: string,
        replacementCode: string,
        manufacturer: string
    ) => {
        openPartDetails(code, replacementCode, manufacturer);
    };

    return (
        <Root>
            <BreadcrumbComponent />

            <Content>
                <SearchResultHeaderContainer
                    display="flex"
                    alignItems="right"
                    padding={0}
                    className="SearchResultHeaderContainer"
                >
                    <SubContainer>
                        <Box p={1} flexGrow={2} style={{ overflow: "hidden" }}>
                            <SearchIconWrapper sx={{ alignItems: "center" }}>
                                <AppIconsSearch2
                                    color="primary"
                                    fontSize="medium"
                                    sx={{ mr: 1 }}
                                />
                                <Typography sx={classes.title}>
                                    {t("common.spareparts.searchpage.title")} :{" "}
                                    {codeSearched}
                                </Typography>
                            </SearchIconWrapper>
                        </Box>
                        <Box
                            p={1}
                            flexGrow={2}
                            style={{
                                overflow: "hidden",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "right",
                            }}
                        ></Box>
                        <ButtonsContainer flexGrow={1}>
                            {!items &&
                                !searching &&
                                searchText &&
                                searchText.length <= 2 && (
                                    <Typography
                                        style={{ marginRight: 20 }}
                                        sx={classes.numberSearchPage}
                                        color="textSecondary"
                                    >
                                        {t(
                                            "common.spareparts.searchpage.perform"
                                        )}
                                    </Typography>
                                )}
                            {items && !searching && (
                                <Typography
                                    style={{ marginRight: 20 }}
                                    sx={classes.numberSearchPage}
                                    color="textSecondary"
                                    variant="body1"
                                >
                                    {items.length > 0 ? (
                                        items.length < 100 ? (
                                            <>
                                                {items.length + " "}
                                                {t(
                                                    "common.spareparts.searchpage.results.title"
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                {t(
                                                    "common.spareparts.searchpage.results.title.truncate"
                                                )}
                                            </>
                                        )
                                    ) : (
                                        <>
                                            {t(
                                                "common.spareparts.searchpage.results.title.no_results"
                                            )}
                                        </>
                                    )}
                                </Typography>
                            )}
                            {searching && (
                                <LinearProgressWrapper
                                    style={{ marginRight: 20 }}
                                >
                                    <LinearProgress color="secondary" />
                                </LinearProgressWrapper>
                            )}

                            <ToggleButtonGroup
                                value={layout}
                                exclusive
                                color="primary"
                                onChange={handleLayoutResult}
                                aria-label="Platform"
                            >
                                <StyledToggleButton
                                    value={gridSearchLayout}
                                    aria-label="grid"
                                >
                                    <AppIconsApp />
                                </StyledToggleButton>
                                <StyledToggleButton
                                    value={tableSearchLayout}
                                    aria-label="table"
                                >
                                    <AppIconsChecklist />
                                </StyledToggleButton>
                            </ToggleButtonGroup>
                        </ButtonsContainer>
                    </SubContainer>
                </SearchResultHeaderContainer>
                <FilterBoxWrapper>
                    <FilterSearch
                        applyFilter={applyFilter}
                        setApplyFilter={setApplyFilter}
                        setSelectedSortType={setSelectedSortType}
                        setSelectedMachineCode={setSelectedMachineCode}
                        setSelectedMachineLabel={setSelectedMachineLabel}
                        expandFilters={expandFilters}
                        setExpandFilters={setExpandFilters}
                        currentMachine={currentMachine}
                        machineFilterApplied={machineFilterApplied}
                    />
                </FilterBoxWrapper>
                <PageContainer>
                    <Box
                        sx={[
                            classes.filtersNotVisible,
                            expandFilters && classes.filtersVisible,
                        ]}
                    >
                        {" "}
                        {items && !searching && (
                            <PartList
                                items={items}
                                layout={layout}
                                loading={searching}
                                onRowClick={handleOpenPartDetail}
                                columns={[
                                    ...(addColumnLogo
                                        ? [
                                              {
                                                  name: "mcc",
                                                  viewHeader: false,
                                                  width: ColumnWidth.IconWidth,
                                                  customComponent:
                                                      PartMccLogoComponent,
                                              },
                                          ]
                                        : []),
                                    {
                                        name: "code",
                                        viewHeader: true,
                                        width: ColumnWidth.ShortTextWidth,
                                        align: ColumnAlign.Left,
                                    },
                                    {
                                        name: "image",
                                        viewHeader: false,
                                        width: ColumnWidth.IconWidth,
                                        customComponent: ImageIconComponent,
                                    },
                                    {
                                        name: "description",
                                        viewHeader: true,
                                        align: ColumnAlign.Left,
                                    },
                                    {
                                        name: "withreplacement",
                                        viewHeader: true,
                                        width: ColumnWidth.IconWidth,
                                        customComponent: ReplaceIconComponent,
                                        align: ColumnAlign.Left,
                                    },
                                    {
                                        name: "showBasket",
                                        viewHeader: false,
                                        width: ColumnWidth.IconWidth,
                                        customComponent: BasketIconComponent,
                                        additionalProps: false,
                                        align: ColumnAlign.Right,
                                    },
                                ]}
                            />
                        )}{" "}
                    </Box>
                </PageContainer>
            </Content>
        </Root>
    );
};

export default SearchPartsPage;
